import {Component, OnInit, ViewChild} from '@angular/core';
import {Helper} from '../../../../helpers/helper.service';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {environment} from '../../../../../environments/environment';
import {UntypedFormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {CollectionService} from '../../../Services/collection.service';
import {DealerProfileService} from '../../../Services/dealer-profile.service';
import {DealerProfile} from '../../../Models/DealerProfile';

@Component({
  selector: 'app-manage-dealer-profile',
  templateUrl: './manage-dealer-profile.component.html',
  styleUrls: ['./manage-dealer-profile.component.scss']
})
export class ManageDealerProfileComponent implements OnInit {

  public classicBox;
  public lastValue = <any>{};
  public enableSave = true;
  form = new UntypedFormGroup({});
  public isEdit = false;
  options: FormlyFormOptions = {};
  @ViewChild('classicForm', {static: false}) child;
  public profileId: number;
  public collections = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public helper: Helper,
    private translate: TranslateService,
    private collectionService: CollectionService,
    private dealerProfileService: DealerProfileService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.profileId = params['id'];
        this.isEdit = true;
        this.dealerProfileService.getProfile(this.profileId).subscribe((profile) => {
          this.lastValue = {profile: profile};
          const lastValueCollections = [];
          profile.collections.forEach(collection => {
            lastValueCollections.push(collection.id);
          });
          this.lastValue.profile.collections = lastValueCollections;
        });
      }
    });

    this.collectionService.getCollection().subscribe((resp) => {
      resp.data.map((value) => {
        this.collections.push({
          label: value.name,
          value: value.id
        });
      });
      this.classicBox = <FormlyFieldConfig>[
        {
          className: 'section-label',
          template: '<div><strong>' + this.translate.instant('admin.dealer_profile.manage.details') + '</strong></div><hr />',
        },
        {
          fieldGroupClassName: 'row',
          key: 'profile',
          fieldGroup: [
            {
              className: 'col-4 ',
              type: 'input',
              key: 'name',
              templateOptions: {
                label: this.translate.instant('doctrine.dealer_profile.name'),
                required: true,
                maxLength: environment.maxStringLength,
              },
              expressionProperties: {
                'templateOptions.disabled': (profile) => {
                  if (profile !== undefined && profile !== null) {
                    return profile.name === DealerProfile.DEFAULT_ALL || profile.name === DealerProfile.DEFAULT_NONE;
                  }
                }
              },
              validation: {
                messages: {
                  pattern: this.translate.instant('errors.invalid'),
                  required: this.translate.instant('errors.required'),
                  maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                },
              },
            },
            {
              key: 'collections',
              type: 'ng-select',
              className: 'col-4 ',
              templateOptions: {
                label: this.translate.instant('doctrine.dealer_profile.collections'),
                multiple: true,
                options: this.collections
              },
            },
          ],
        },
      ];
    });
  }

  enableButton(event) {
    this.enableSave = event;
  }

  submitItem(next: boolean) {
    if (next) {
      const profile = JSON.parse(JSON.stringify(this.lastValue));
      delete profile.profile.id;
      delete profile.profile.position;

      this.dealerProfileService.manageProfile(profile, this.isEdit, this.profileId).subscribe((resp) => {
        this.router.navigateByUrl('/back-office/dealer-profile/overview');
      });
    } else {
      this.router.navigateByUrl('/back-office/dealer-profile/overview');
    }
  }
}
